import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WebtrekkConfigService } from 'src/app/webtrekk-config.service';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { take } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class BannerWebtrekkTrackingService {
    private platformId = inject(PLATFORM_ID);
    currentB2bUnitSendToWebtrack !: string;

    constructor(
        private webtrekk: WebtrekkConfigService, private activeCartService: ActiveCartFacade,) { }
    getCountryCode(): string {
        return isPlatformBrowser(this.platformId) ? window.location.pathname.split('/')[1] : '';
    }
    trackAction(name: string) {
        // SSR-safe
        let actionName: string;
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        if (name.includes('Econx')) {
            actionName = 'Banner_Econx';
        } else if (name.includes('Up2Date')) {
            actionName = 'Banner_up2date';
        } else {
            actionName = 'banner';
        }
        this.activeCartService.getActive().pipe(
            take(1)
        ).subscribe((item: any) => {
            this.webtrekk.runWhenReady(() => {
                (window as any).wtSmart?.action?.data?.set({
                    name: actionName,
                    parameter: {
                        7: this.getCountryCode(),
                        8: item?.currentB2BUnit?.uid
                    }
                });
                (window as any).wtSmart?.track();
                console.log('[webtrekk] Action tracked:', actionName);
            })
        });
    }
}
